export class DatabaseOrgDataService {
	private id: string | undefined = undefined;

	updateOrgId(id: string): void {
		this.id = id;
	}

	getId(): string | undefined {
		return this.id;
	}
}
